import Switch, { SwitchProps } from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { ReactNode } from "react";

export function PermissionToggle(props: Readonly<SwitchProps>): ReactNode {
  const { 
    checked, 
    color, 
    onChange, 
    disabled, 
    ...rest 
  } = props;

  const checkedText = checked ? 'Disable' : 'Enable';
  const tooltipTitle = disabled ? '' : `${checkedText} Permission`;

  return (
    <Tooltip title={tooltipTitle} disableInteractive>
      <span>
        <Switch
          {...rest}
          disabled={disabled}
          size="small"
          checked={checked}
          edge="start"
          onChange={onChange}
          sx={{
            '& .MuiSwitch-switchBase': {
              '&.Mui-checked': {
                '&.Mui-disabled': {
                  color: color,
                  opacity: 0.5
                },
                color,
                '& + .MuiSwitch-track': { backgroundColor: color }
              }
            }
          }}
        />
      </span>
    </Tooltip>
  );
}
